import { BaseEdge, EdgeLabelRenderer, getBezierPath, type EdgeProps } from '@xyflow/react';
import type { ArestaSetaTipo } from './montar-nos-notas';

/**
 * Seta entre post-its, cartões e grupos (RQ-NOT-004, RQ-COL-008): traço com gradiente da primária (clara na origem,
 * cheia no destino), ponto na origem, ponta recortada no destino e halo quando selecionada; rótulo opcional no meio.
 * O gradiente usa as coordenadas da tela para seguir a direção da seta, qualquer que seja o sentido.
 */
export function ArestaSeta(props: EdgeProps<ArestaSetaTipo>) {
  const { id, sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition, data, selected } = props;
  const [caminho, rotuloX, rotuloY] = getBezierPath({ sourceX, sourceY, targetX, targetY, sourcePosition, targetPosition });
  const chave = id.replace(/[^\w-]/g, '');
  const ponta = `seta-ponta-${chave}`;
  const gradiente = `seta-gradiente-${chave}`;
  return (
    <>
      <defs>
        <linearGradient id={gradiente} gradientUnits="userSpaceOnUse" x1={sourceX} y1={sourceY} x2={targetX} y2={targetY}>
          <stop offset="0" className="seta__cor-inicio" />
          <stop offset="1" className="seta__cor-fim" />
        </linearGradient>
        <marker id={ponta} viewBox="0 0 18 16" refX="15" refY="8" markerWidth="18" markerHeight="16" markerUnits="userSpaceOnUse" orient="auto">
          <path d="M 2 2 L 16 8 L 2 14 L 6 8 Z" className="seta__ponta" />
        </marker>
      </defs>
      <path d={caminho} className={selected ? 'seta__halo seta__halo--selecionada' : 'seta__halo'} />
      <BaseEdge
        id={id}
        path={caminho}
        markerEnd={`url(#${ponta})`}
        className={selected ? 'seta seta--selecionada' : 'seta'}
        style={{ stroke: `url(#${gradiente})` }}
        interactionWidth={24}
      />
      <circle cx={sourceX} cy={sourceY} r={4.5} className="seta__origem" />
      {data?.rotulo && (
        <EdgeLabelRenderer>
          <span className="seta__rotulo nodrag nopan" style={{ transform: `translate(-50%, -50%) translate(${rotuloX}px, ${rotuloY}px)` }}>
            {data.rotulo}
          </span>
        </EdgeLabelRenderer>
      )}
    </>
  );
}
